import React, {memo} from 'react';
import {PencilImg} from './../style'; // твой стилизованный компонент
import editIcon from '#app/assets/icons/edit.svg'; // статический импорт (быстрее чем require)

export const EditIcon = memo(({ hovered, handleClick, item }) => {
    if (item.isNotVisibleSum) return null;

    return (
        <PencilImg
            style={{ display: hovered ? 'block' : 'none' }}
            src={editIcon}
            onClick={() => handleClick(item.id, item.payment_id)}
            alt="Редактировать"
        />
    );
});